import React from "react";
import PagingButtons from "src/components/molecules/PagingButtons";
import PagingInfo from "./PagingInfo";
import { Container } from "./styles";

type Props = {
  currentPage: number;
  rowsPerPage: number | null;
  totalRowCount: number;
  onPageChange(newPage: number): void;
};

const TableFooter = ({ onPageChange, ...rest }: Props) => (
  <Container>
    <PagingButtons onPageChange={onPageChange} {...rest} />
    <PagingInfo {...rest} />
  </Container>
);

export default TableFooter;
